import { ECompanyType } from '../../../../../repositories/coworking/v1/apply-for-publication';

import { TValidationRules } from '../../types';
import { EPlacementApplicationFormFields } from '../../enums';
import { EMAIL_VALIDATION_REG_EX, PHONE_VALIDATION_REG_EX } from '../constants';

export const validationRules: TValidationRules = {
  [EPlacementApplicationFormFields.Email]: (value: string) => {
    if (value.length === 0) {
      return 'Введите e-mail';
    }

    if (value.length > 254) {
      return 'Максимальное количество символов – 254';
    }

    if (EMAIL_VALIDATION_REG_EX.test(value)) {
      return null;
    }

    return 'Введите корректный e-mail';
  },
  [EPlacementApplicationFormFields.CompanyType]: (value: ECompanyType) => {
    if (value.length === 0) {
      return 'Выберите вид деятельности';
    }

    return null;
  },
  [EPlacementApplicationFormFields.Phone]: (value: string) => {
    if (value.length === 0) {
      return 'Введите номер телефона';
    }

    if (PHONE_VALIDATION_REG_EX.test(value)) {
      return null;
    }

    return 'Введите корректный номер телефона';
  },
  [EPlacementApplicationFormFields.CompanyName]: (value: string) => {
    if (value.length === 0) {
      return 'Введите название компании';
    }

    if (value.length > 200) {
      return 'Максимальное количество символов – 200';
    }

    return null;
  },
};

export const validationRulesEntries = Object.entries(validationRules) as Array<
  [keyof TValidationRules, TValidationRules[keyof TValidationRules]]
>;
